export const labelFontFamily = 'Helvetica, Arial, Courier';
export const animationDuration = 3000;
export const animationEasing = 'easeOutQuart';
export const xLabelFormat = {
  autoSkip: false,
  fontColor: '#424242',
  fontFamily: labelFontFamily,
  fontSize: 14,
  lineHeight: 1.5,
  maxRotation: 0
};

export const getYearRangeLabels = (
  firstYear,
  lastYear
) => (
  [...Array((lastYear + 1) - firstYear).keys()]
    .map((key) => key + firstYear)
);

export const determineXLabels = function () {
  const xLabels = [];
  const xLabelMin = 1976;
  const xLabelMax = 2024;
  let xLabelTick = 6;
  if (window.innerWidth < 1024) {
    xLabelTick = 9;
  }
  for (let i = xLabelMin; i <= xLabelMax; i++) {
    if ((i - xLabelMin) % xLabelTick === 0) {
      if (
        (xLabelMax - i) <= (xLabelTick / 2) &&
        i !== xLabelMax
      ) {
        xLabels.push('');
        continue;
      }
      xLabels.push(i.toString(10));
      continue;
    }
    if (i + 1 <= xLabelMax) {
      xLabels.push('');
    } else {
      xLabels.push(i);
    }
  }
  return xLabels;
};

export const determineQuarterlyXLabels = (
  firstYear,
  lastYear,
  startingQuarter = 1,
  endingQuarter = 4,
  labelFrequency = null
) => (
  getYearRangeLabels(firstYear, lastYear)
    .flatMap((year) => {
      const quarters = (() => {
        if (year === firstYear) {
          return (
            [...Array(5 - startingQuarter).keys()]
              .map((key) => key + startingQuarter)
          );
        }
        if (year === lastYear) {
          return (
            [...Array(endingQuarter).keys()]
              .map((key) => key + 1)
          );
        }
        return (
          [...Array(4).keys()]
            .map((key) => key + 1)
        );
      })();
      return (
        quarters.map(
          (quarter) => `Q${quarter} ${year}`
        )
      );
    }).map(
      (quarter, index) => {
        const n = (() => {
          if (typeof labelFrequency === 'function') {
            return labelFrequency();
          }
          return window.innerWidth >= 1024 ? 2 : 4;
        })();
        return (index - 1) % n !== 0 ? '' : quarter;
      }
    )
);
